import React, { useState } from "react";
import Footer from "../components/Footer";

const CsrActivity = () => {
  const [previewImage, setPreviewImage] = useState(null);
  const [showAllCSR, setShowAllCSR] = useState(false);
  const [showAllSchool, setShowAllSchool] = useState(false);
  const [showAllBlankets, setShowAllBlankets] = useState(false);

  const csrData = [
    { id: 1, image: "/images/plantation1.jpg" },
    { id: 2, image: "/images/plantation2.jpg" },
    { id: 3, image: "/images/plantation3.jpg" },
    { id: 4, image: "/images/plantation4.jpg" },
    { id: 5, image: "/images/plantation5.jpg" },
    { id: 6, image: "/images/WhatsApp Image 2025-09-13 at 15.47.31_27785361.jpg" },
    { id: 7, image: "/images/WhatsApp Image 2025-09-13 at 15.48.30_30867601.jpg" },
    { id: 8, image: "/images/WhatsApp Image 2025-09-13 at 15.48.49_208038ba.jpg" },

  ];

  const csrSchoolData = [
    { id: 1, image: "/images/school1.jpg" },
    { id: 2, image: "/images/school2.jpg" },
    { id: 3, image: "/images/school3.jpg" },
    { id: 4, image: "/images/school4.jpg" },
  ];

  const blanketImages = [
    "/images/blanket2.jpg",
    "/images/blanket3.jpg",
    "/images/blanket4.jpg",
    "/images/blanket5.jpg",
    "/La-maison-gallary/Blanket-Distribution1.jpg",
    "/La-maison-gallary/Blanket-Distribution2.jpg",
    "/La-maison-gallary/Blanket-Distribution3.jpg",
    "/La-maison-gallary/Blanket-Distribution4.jpg",
    "/La-maison-gallary/Blanket-Distribution5.jpg",
    "/La-maison-gallary/Blanket-Distribution6.jpg",
    "/Blanket-Distribution-Prajkata-Park2.jpg",
    "/Blanket-Distribution-Prajkata-Park3.jpg",
  ];

  const renderImages = (images, showAll, setShowAll) => (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mt-10">
        {(showAll ? images : images.slice(0, 3)).map((img, index) => (
          <div
            key={index}
            className="rounded-2xl overflow-hidden mx-auto cursor-pointer group"
            onClick={() => setPreviewImage(img.image || img)}
          >
            <img
              src={img.image || img}
              alt={`Image ${index + 1}`}
              className="w-[70vh] h-[70vh] object-cover transition-transform duration-300 group-hover:scale-105"
            />
          </div>
        ))}
      </div>

      {images.length > 3 && (
        <div className="text-center mt-6">
          <button
            onClick={() => setShowAll(!showAll)}
            className="px-6 py-2 bg-[#011321] text-white rounded-full shadow hover:bg-gray-800 transition"
          >
            {showAll ? "Show Less" : "View More"}
          </button>
        </div>
      )}
    </>
  );

  return (
    <div className="min-h-screen bg-[#e8ebf1]">
      {/* CSR Activity Header */}
      <section
        className="relative pt-28 pb-20 text-white overflow-hidden"
        style={{
          backgroundImage: "url('/images/csr_activity.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          height: '90vh',
        }}
      >
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-10 sm:top-20 right-10 sm:right-20 w-48 sm:w-96 h-48 sm:h-96 bg-white rounded-full blur-2xl"></div>
          <div className="absolute bottom-10 sm:bottom-20 left-10 sm:left-20 w-40 sm:w-64 h-40 sm:h-64 bg-white rounded-full blur-2xl"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto h-full flex flex-col items-center justify-center px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-3xl sm:text-5xl md:text-6xl font-bold leading-tight mb-4 sm:mb-6">
            <span className="text-white">Our Commitment</span>
          </h1>
          <p className="text-base sm:text-lg md:text-xl max-w-3xl sm:max-w-4xl mx-auto leading-relaxed font-bold">
            Empowering lives and building a sustainable future.
          </p>
        </div>
      </section>

      <div className="py-16 sm:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

          {/* ---------------------- Mother Green Section ---------------------- */}
          <div className="my-12 sm:mb-16">
            <div className="flex items-center gap-3 mb-2">
              <img src="/images/logo.png" alt="CSR Logo" className="w-8 h-8 sm:w-10 sm:h-10 object-contain" />
              <h2 className="text-black font-bold text-xl sm:text-2xl">
                An initiative towards Mother Green:
              </h2>
            </div>
            <div className="w-100 h-1 bg-[#011321] mb-4 rounded-full"></div>
            <p className="text-base sm:text-xl text-gray-600">
              In every project, we have a plan to plant regularly 11 to 12 plants
              by the roadside or near the ongoing projects and maintain it till
              they achieve their strength.
            </p>

            {renderImages([...csrData].reverse(), showAllCSR, setShowAllCSR)}
          </div>

          {/* ---------------------- School Distribution Section ---------------------- */}
          <div className="my-12 sm:mb-16">
            <div className="flex items-center gap-3 mb-2">
              <img src="/images/logo.png" alt="CSR Logo" className="w-8 h-8 sm:w-10 sm:h-10 object-contain" />
              <h2 className="text-black font-bold text-xl sm:text-2xl">
                Spreading Smiles Through Education Support:
              </h2>
            </div>
            <div className="w-100 h-1 bg-[#011321] mb-4 rounded-full"></div>
            <p className="text-base sm:text-xl text-gray-600">
              As part of our CSR initiative, we regularly organize school distribution drives
              where we provide essential items such as school bags, water bottles, and tiffin boxes
              to underprivileged children. Our goal is to support their education journey,
              encourage regular school attendance, and bring joy to their learning experience.
            </p>

            {renderImages([...csrSchoolData].reverse(), showAllSchool, setShowAllSchool)}
          </div>

          {/* ---------------------- Blanket Distribution Section ---------------------- */}
          <div className="my-12 sm:mb-16">
            <div className="flex items-center gap-3 mb-2">
              <img src="/images/logo.png" alt="CSR Logo" className="w-8 h-8 sm:w-10 sm:h-10 object-contain" />
              <h2 className="text-black font-bold text-xl sm:text-2xl">
                An Initiative to Spread Warmth:
              </h2>
            </div>
            <div className="w-100 h-1 bg-[#011321] mb-4 rounded-full"></div>
            <p className="text-base sm:text-xl text-gray-600">
              In each of our projects, we carry out an initiative to distribute blankets to underprivileged and needy families. These blankets help them stay warm during the cold season, and their well-being is cared for with love.
            </p>

            {renderImages([...blanketImages].reverse(), showAllBlankets, setShowAllBlankets)}
          </div>

          {/* ---------------------- PYAU Facilities Section ---------------------- */}
          <div className="my-12 sm:mb-16">
            <div className="flex items-center gap-3 mb-2">
              <img src="/images/logo.png" alt="CSR Logo" className="w-8 h-8 sm:w-10 sm:h-10 object-contain" />
              <h2 className="text-black font-bold text-xl sm:text-2xl">“PYAU” Facilities:</h2>
            </div>
            <div className="w-100 h-1 bg-[#011321] mb-4 rounded-full"></div>
            <p className="text-base sm:text-xl text-gray-600">
              In every project, we install “PYAU”, which provides drinking water
              facilities to the workers on the construction site and also for all the
              other people who pass by.
            </p>
            <div className="max-w-lg">
              <img
                src="/images/crs-1200x675.jpeg"
                alt="PYAU"
                className="w-full h-auto rounded-2xl shadow-lg cursor-pointer"
                onClick={() => setPreviewImage("/images/crs-1200x675.jpeg")}
              />
            </div>
          </div>

          {/* ---------------------- Community Support Section ---------------------- */}
          <div className="my-12 sm:mb-16">
            <div className="flex items-center gap-3 mb-2">
              <img src="/images/logo.png" alt="CSR Logo" className="w-8 h-8 sm:w-10 sm:h-10 object-contain" />
              <h2 className="text-black font-bold text-xl sm:text-2xl">Community Support:</h2>
            </div>
            <div className="w-100 h-1 bg-[#011321] mb-4 rounded-full"></div>
            <p className="text-base sm:text-xl text-gray-600">
              On the occasion of Gajanan Maharaj Pragat Din, our volunteers distribute prasad in front of our site, extending the spirit of togetherness and devotion. Through this initiative, we aim to share happiness and strengthen our bond with the community.
            </p>

            {/* Videos */}
            <div className="flex flex-wrap gap-6 mt-6">
              <div className="relative overflow-hidden w-full sm:w-[320px] md:w-[400px] group">
                <iframe
                  className="rounded-2xl w-full h-64 md:h-72 shadow-lg"
                  src="https://www.youtube.com/embed/ZzDdl_TrJys"
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                ></iframe>
              </div>

              <div className="relative overflow-hidden w-full sm:w-[320px] md:w-[400px] group">
                <iframe
                  className="rounded-2xl w-full h-64 md:h-72 shadow-lg"
                  src="https://www.youtube.com/embed/AObgUN7AjYk"
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* Image Preview Modal */}
      {previewImage && (
        <div
          className="fixed inset-0 bg-black/90 flex items-center justify-center z-50 p-4"
          onClick={() => setPreviewImage(null)}
        >
          <div className="relative w-full h-full max-w-[95vw] max-h-[95vh]">
            <img
              src={previewImage}
              alt="Preview"
              className="w-full h-full object-contain rounded-xl shadow-2xl"
            />
            <button
              onClick={() => setPreviewImage(null)}
              className="absolute top-2 right-2 bg-red-600 text-white px-3 py-1 rounded-full shadow-lg hover:bg-red-700"
            >
              ✕
            </button>
          </div>
        </div>
      )}

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default CsrActivity;
